<div class="callout help">
  <p [innerHTML]="textkeyprefix + '.' + topic + '.hilfe' | translate"></p>
  <button class="close" [attr.aria-label]="'arialabel.close' | translate" [title]="textkeyprefix + '.close' | translate" (click)="onClose()"><i class="icon-x"></i></button>
</div>
